import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/authReducer';
import taskListReducer from './reducers/taskListReducer';
import taskDetailReducer from './reducers/taskDetailReducer';
import { createSocketMiddleware } from '../utils/socket';
import baseApi from '../api/baseApi';

const reducer = {
  auth: authReducer,
  taskList: taskListReducer,
  taskDetail: taskDetailReducer,
  [baseApi.reducerPath]: baseApi.reducer
};
const preloadedState = {};

const store = configureStore({
  reducer,
  preloadedState,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(createSocketMiddleware(), baseApi.middleware)
});

export default store;
